<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="plus"></i> Yeni Model Ekle
    </h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="brandModelForm">
        <div class="col-12">
            <div class="form-group">
                <label for="brandId">Marka Seç</label>
                <ng-select [items]="brands" bindLabel="brandName" bindValue="id" formControlName="brandId">
                </ng-select>
                <span *ngIf="brandModelForm.get('brandId')?.invalid && brandModelForm.get('brandId')?.touched"
                    class="text-danger">
                    Marka Zorunludur
                </span>
            </div>
        </div>

        <div class="col-12">
            <div class="form-group">
                <label for="brandModelName">Model Adı </label>
                <input type="text" class="form-control" formControlName="brandModelName" id="basicInput"
                    [placeholder]="brandModelForm.value.brandId ? 'Model' : 'Marka'" />
                <span *ngIf="brandModelForm.get('brandModelName')?.invalid && brandModelForm.get('brandModelName')?.touched"
                    class="text-danger">
                    Marka Zorunludur
                </span>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="brandModelForm.invalid"
        (click)="onSumbit()">Kaydet</button>
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
</div>